import {Card, StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core";
import * as React from "react";

import {ActionButton} from "../../../../../components/Buttons/ActionButton/ActionButton";
import {IFormField} from "../../../../../state/model/SharedTypes";
import SLTextFieldNew from "../../../../../components/Input/SLTextFieldNew";
import {CreaditCardMaskedInput} from "../../../../../components/Payments/CardPaymentForm/components/CreaditCardMaskedInput";
import SLSelectContainerNew, {SelectItem} from "../../../../../components/SLSelect/SLSelectContainerNew";
// import CardPaymentFormTerms from "../../../../../components/Payments/CardPaymentForm/components/CardPaymentFormTerms";
import {CreditCardIcons} from "../../../../../components/Icons/CreditCardIcons/CreditCardIcons";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";

interface IProps {
    paymentAmount : string;
    cardHolderName : IFormField < string >;
    onCardHolderNameChanged : (val : string) => void;
    cardNumber : IFormField < string >;
    onCardNumberChanged : (val : string) => void;
    cardCode : IFormField < string >;
    onCardCodeChanged : (num : string) => void;
    exiprationMonth : IFormField < string >;
    expirationMonths : string[];
    onExiprationMonthChanged : (num : string) => void;
    expirationYears : string[];
    exiprationYear : IFormField < string >;
    onExiprationYearChanged : (num : string) => void;
    onSubmitClicked : () => void;
    errorMessage?: string;
    className?: string;
    isPosting : boolean;
    coworkDisplayName : string;
    isFormFinished: boolean;
    store: any
}

const styles : StyleRulesCallback = ({palette, breakpoints, spacing}) => ({
    title: {
        fontSize: 40,
        fontWeight: "bold",
        textAlign: "center",
        [breakpoints.down("lg")]: {
            fontSize: 32
        },
        [breakpoints.down("sm")]: {
            fontSize: 20
        }
    },
    container: {
        marginTop: "1em",
        display: "flex",
        flexDirection: "column",
        boxShadow: "none",
        [breakpoints.down("sm")]: {

        }
    },
    textFieldMargin: {
        marginBottom: "1.7em",
        fontSize: "13px!important",
        [breakpoints.down("sm")]: {
            marginBottom: 30
        }
    },
    expirationContainer: {
        width: "99%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        [breakpoints.down("sm")]: {
            marginBottom: 15,
            width: "96%",
        }
    },
    expirationInput: {
        flex: "1",
        maxWidth: 144
    },
    errorMessage: {
        marginBottom: 20,
        fontSize: 16,
        color: palette.error.main,
        lineHeight: 1,
        minHeight: 16,
        textAlign: "center",
        [breakpoints.down("sm")]: {
            fontSize: 14,
            minHeight: 14,
            marginBottom: 0
        }
    },
    verified: {
        fontSize: 13,
        fontWeight: 500,
        color: "#2f3033",
        textAlign: "center",
        [breakpoints.down("sm")]: {
            width: "95%"
        },
    },
    actionButton: {
        width: "99%!important",
        height: "3em",
        borderRadius: "10px",
        backgroundColor: "#ffba00",
        color: "#2f3033",
        fontSize: 15,
        fontWeight: "bold",
        marginBottom: ".6em",
        [breakpoints.down("sm")]: {
            width: "96%!important",
            alignSelf: "stretch",
            height: 50,
        },
        "&:hover": {
            backgroundColor: "#FFCF50",
        }
    },
    disabled: {
        width: "100%!important",
        height: "3em",
        borderRadius: "10px",
        backgroundColor: "#E1E6EA",
        color: "white",
        fontSize: 15,
        fontWeight: "bold",
        marginBottom: ".6em",
        [breakpoints.down("sm")]: {
            width: "96%!important",
            alignSelf: "stretch",
            height: 50,
        },
        "&:hover": {
            backgroundColor: "#E1E6EA!important",
        }
    },
    boldAction: {
        fontWeight: 900
    },
    buttonProgress: {
        color: palette.common.black,
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    },
    creditIcons: {
        objectFit: "contain",
        width: "80%",
        margin: "auto",
        marginTop: "2em"
    },
    terms: {
        marginTop: spacing.unit * 2,
        fontSize: 13,
        fontWeight: 500,
        lineHeight: 1.5
    },
    cvvTextfield: {
        flexShrink: 1
    },
    textFieldLabel: {
        fontSize: 14,
        color: "#2F3033"
    }
});

@(withStyles(styles)as any)
export default class CardPaymentForm extends React.Component < IProps & Partial < WithStyles < any >> > {
    public render() {
        const {classes, errorMessage, className, store} = this.props;
        const texts = this.getPaymentsTexts();
        return (
            <Card
                className={[
                    classes !.container,
                    className
                ].join(" ")}
                elevation={1}>
                {this.renderCardHolderName()}
                {this.renderCardNumber()}
                {this.renderExpirationContainer()}
                <div className={classes !.errorMessage}>{errorMessage}</div>
                {this.renderActionButton(texts.buttonText)}
                {store.paymentError? <div className="plaid-error">{store.paymentError}</div> : null}
                <div className={classes!.verified}>
                    {texts.bottomText}
                </div>
                <CreditCardIcons className={classes !.creditIcons}/>
            </Card>
        );
    }

    private renderCardHolderName() {
        const {classes, cardHolderName, onCardHolderNameChanged, isPosting} = this.props;
        return (
            <>
                <div className={classes!.textFieldLabel}>Name on card</div>
                <SLTextFieldNew
                    className={classes !.textFieldMargin}
                    errorText={cardHolderName.error}
                    onChange={onCardHolderNameChanged}
                    textFieldProps={{
                        disabled: isPosting,
                        value: cardHolderName.data,
                        placeholder: "John Doe"
                    }}/>
            </>
        );
    }

    private renderCardNumber() {
        const {classes, cardNumber, onCardNumberChanged, isPosting} = this.props;
        return (
            <>
                <div className={classes!.textFieldLabel}>Card number</div>
                <SLTextFieldNew
                    className={classes !.textFieldMargin}
                    errorText={cardNumber.error}
                    onChange={onCardNumberChanged}
                    inputComponent={CreaditCardMaskedInput}
                    textFieldProps={{
                        disabled: isPosting,
                        value: cardNumber.data
                    }}
                />
            </>
        );
    }

    private renderExpirationContainer() {
        const {
            classes,
            exiprationMonth,
            expirationMonths,
            exiprationYear,
            expirationYears,
            cardCode,
            onCardCodeChanged,
            isPosting
        } = this.props;
        return (
            <div className={classes !.expirationContainer}>
                <SLSelectContainerNew
                    label="Expiration date"
                    className={""}
                    isErrorOnSameLine={cardCode.error !== undefined}
                    fullWidth={true}
                    selectedItem={this.selectItemDummyMapper(exiprationMonth.data !)}
                    onItemSelected={this.onExpirationMonthChanged}
                    items={expirationMonths.map(this.selectItemDummyMapper)}
                    disabled={isPosting}/>
                <SLSelectContainerNew
                    className={""}
                    isErrorOnSameLine={cardCode.error !== undefined}
                    fullWidth={true}
                    selectedItem={this.selectItemDummyMapper(exiprationYear.data !)}
                    onItemSelected={this.onExpirationYearChanged}
                    items={expirationYears.map(this.selectItemDummyMapper)}
                    disabled={isPosting}/>

                <SLTextFieldNew
                    label="CVV"
                    isShortInput={true}
                    errorText={cardCode.error}
                    onChange={onCardCodeChanged}
                    textFieldProps={{
                        value: cardCode.data,
                        placeholder: "123",
                        disabled: isPosting
                    }}/>
            </div>
        );
    }

    private renderActionButton(text: string) {
        const {classes, onSubmitClicked, isPosting} = this.props;
        return (
            <ActionButton
                onClick={onSubmitClicked}
                className={isPosting? classes !.disabled :  classes !.actionButton}>
                <div>
                    {text}
                </div>
            </ActionButton>
        );
    }

    private getPaymentsTexts = () => {
        const {store} = this.props;
        const unverifiedUserTexts = {
            buttonText: "Verify card",
            bottomText: "Not billed until you’re funded!"
        };
        const myAccountReplaceCardText = {
            buttonText: "Replace card",
            bottomText: ""
        }
        const myAccountSubmitPaymentText = {
            buttonText: "Submit payment",
            bottomText: ""
        }
        // Coming from MyAccount
        if(!store.uid) {
            return store.isVerified ? myAccountSubmitPaymentText : myAccountReplaceCardText
        }
        // Coming from Signup
        if(store.formInput.plans && store.formInput.plans.plansValue) {
            if(!store.isVerified) {
                return unverifiedUserTexts;
            }
            switch (store.formInput.plans.plansValue) {
                case LeadPlanType.Deposit:{
                    return {
                        buttonText: "Submit payment",
                        bottomText: "You can cancel anytime."
                    }
                }
                case LeadPlanType.Rent:
                case LeadPlanType.Loan:{
                    return {
                        buttonText: "Submit $" + store.getmonthlyPaymentAmount + " payment",
                        bottomText: "You can cancel anytime."
                    }
                }
                case LeadPlanType.DepositRent: return unverifiedUserTexts;
            }
        }
        return unverifiedUserTexts;
    };

    private selectItemDummyMapper = (val : string) : SelectItem => ({displayString: val, value: val});

    private onExpirationMonthChanged = (item : SelectItem) => this
        .props
        .onExiprationMonthChanged(item.value);

    private onExpirationYearChanged = (item : SelectItem) => this
        .props
        .onExiprationYearChanged(item.value);
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/components/PaymentFormContainer/PaymentForm/PaymentForm.tsx